import Vapi from 'vuex-rest-api';

const fetcherAdminChannel = new Vapi({
  state: {
    fetcherAdminChannel: {
      cid: '',
    },
  },
})
  .get({
    action: 'getFetcherAdminChannel',
    property: 'fetcherAdminChannel',
    path: ({ cid }) => `/api/fetcher/admin/channels/${cid}`,
  })
  .getStore();

export default fetcherAdminChannel;
